const today = new Date();

export const invoiceDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;

export const placeOfSupply = '';

export const supplier = {
  name: 'Vidyut Cloud',
  address: 'B/1904, Atlanta Enclave, Near Ecov Ista, Kalyan Shilphata, Thane, Maharashtra, 400612',
  state: 'Maharashtra',
  gstin: '27AAWFV4391F1ZH',
  pan: 'AAWFV4391F',
  contact: '+91-8169517831/ +91-7758800791',
  email: 'info@vidyutcloud.com'
};

export const recipient = {
  name: '',
  address: '',
  state: '',
  gstin: '',
  contact: '',
  email: ''
};

export const bank = {
  name: 'Union Bank',
  accountNo: '558501010035835',
  accountType: 'Current',
  ifsc: 'UBIN0555851'
};

export const packageOptions = {
  'Basic Package': {
    '1 Year': 35000,
    '2 Years': 55000,
    '3 Years': 70000
  },
  'Advanced Package': {
    '1 Year': 42000,
    '2 Years': 70000,
'3 Years': 95000
  },
  'SELLER SERVICES PACKAGE': {
    '1 Year': 42000,
    '2 Years': 70000,
    '3 Years': 95000
  }
};

export const getDefaultProduct = () => {
  const packageType = '';
  const duration = '';
  return {
    packageType,
    duration,
    description: `${packageType} for ${duration}`,
    hsn: '9973',
    qty: 1,
    rate: packageOptions[packageType]?.[duration] || 0,
    discount: 0,
    cgst: 0,
    sgst: 0,
    igst: 0
  };
};

export const getCurrentMonthYearSuffix = () => {
  const now = new Date();
  const month = now.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  const year = now.getFullYear().toString().slice(-2);
  return `${month}/${year}`;
};
